import fifthaveClient from './fifthaveClient';

// 获取全部分类
export function getAllCategory() {
    return fifthaveClient.get('/api/v1/_internal/frontend-categories');
}

// 上传前台分类图片
export function postImage(imageType, data) {
    return fifthaveClient.post(`/api/v1/_intenal/upload/images/${imageType}`, data);
}

// 新增/修改分类
export function postCategory(data) {
    return fifthaveClient.post('/api/v1/_internal/frontend-categories', data);
}

// 删除分类
export function deleteCategory(id: string) {
    return fifthaveClient.delete('/api/v1/_internal/frontend-categories', {
        data: [id]
    })
}

// 分类排序
export function sortCategory(data) {
    return fifthaveClient.patch('/api/v1/_internal/frontend-categories/priorities', {
        fcIds: data
    })
}